module.exports = __webpack_public_path__ + "static/nlp-200cc9da964aefaecde59e1d8c2a8231.png";